// extracted by mini-css-extract-plugin
module.exports = {"declaration":"_9EwjfaXpoTnScqWd4G2F5w==","footer":"yW3ISiImwlv6jK-kwxlm6Q=="};